import React from 'react';
import Icon from '@ant-design/icons';

const BrainSvg: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  const maskId = `brain-mask-${React.useId().replace(/:/g, '')}`;

  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#000" />
          <path
            fill="#fff"
            d="M11.35 3.35C10.35 2.08 8.2 2.18 7.3 3.7 5.48 3.58 4.2 5.2 4.6 6.9 3.06 7.72 2.72 9.76 3.76 11.08 2.55 12.38 2.92 14.55 4.42 15.42c-.52 1.88.93 3.63 2.77 3.58.6 1.87 3.1 2.38 4.16.72V3.35Zm1.3 0c1-1.27 3.15-1.17 4.05.35 1.82-.12 3.1 1.5 2.7 3.2 1.54.82 1.88 2.86.84 4.18 1.21 1.3.84 3.47-.66 4.34.52 1.88-.93 3.63-2.77 3.58-.6 1.87-3.1 2.38-4.16.72V3.35Z"
          />
          <g fill="none" stroke="#000" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11.35 6.1c-1.2-1.35-2.4-1.62-3.55-.8M11.35 9.45c-1.6.35-2.25-.25-2.78-1.28M11.35 13.2c-1.12.92-2.3.6-2.86-.45M11.35 16.75c-1.7-1.04-3.16-.4-3.3 1.03M12.65 6.1c1.2-1.35 2.4-1.62 3.55-.8M12.65 9.45c1.6.35 2.25-.25 2.78-1.28M12.65 13.2c1.12.92 2.3.6 2.86-.45M12.65 16.75c1.7-1.04 3.16-.4 3.3 1.03M12 3.1v17.6" />
          </g>
        </mask>
      </defs>
      <rect width="24" height="24" fill="currentColor" mask={`url(#${maskId})`} />
    </svg>
  );
};

type BrainIconProps = Omit<React.ComponentProps<typeof Icon>, 'component'>;

const BrainIcon: React.FC<BrainIconProps> = props => (
  <Icon component={BrainSvg} aria-label="Intelligence" {...props} />
);

export default BrainIcon;
